import {Component, ElementRef, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {BusinessStructureProvider} from '@providers/business-structure/business-structure.provider';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {Observable} from 'rxjs';
import {LaboratoryDocument} from '@models/laboratory-document';
import {map} from 'rxjs/operators';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    providers: [],
    selector: 'organization-common-fields',
    templateUrl: './organization-common.component.html'
})
export class OrganizationCommonComponent extends AbstractFields implements OnInit {

    public navigation = [
        {title: 'Данные организации', anchor: 'wizard-organization-common-data'},
        {title: 'Документы организации', anchor: 'wizard-organization-common-documents'},
    ];

    public documentsToView$: Observable<LaboratoryDocument[]>;

    public canAddDocuments = false;

    constructor(
        public elementRef: ElementRef,
        public businessStructure: BusinessStructureProvider,
        private documentsProvider: LaboratoryDocumentsProvider,
        private authService: AuthService,
    ) {
        super();

        this.documentsToView$ = this.documentsProvider.data$.pipe(
            map((list: LaboratoryDocument[]) => list.filter(item => {
                return [
                    LaboratoryDocumentsNamespace.DocumentTypeEnum.custom,
                    LaboratoryDocumentsNamespace.DocumentTypeEnum.rostehLicense,
                ].includes(item.type);
            }))
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.canAddDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentCreate]);
    }

    /**
     * Копирует наименование в качестве короткого наименования
     */
    copyTitleToShort() {
        this.form.get('short_title').patchValue(this.form.get('title').value);
    }
}
